import { useWidgetEnvironment } from "@/components/dashboard-grid";

/**
 * Tone: the five meaning colours and the motion switch.
 *
 * Part of the widget primitive vocabulary — see ./index.ts. Widgets differ in
 * what they measure, not in how a number, a chart or a person-row looks, so
 * every shape lives here rather than being re-invented per widget.
 */

export type TWidgetTone = "primary" | "info" | "success" | "warning" | "danger";

export const TONE_TEXT: Record<TWidgetTone, string> = {
  primary: "text-primary",
  info: "text-info",
  success: "text-success",
  warning: "text-warning",
  danger: "text-danger",
};

export const TONE_FILL: Record<TWidgetTone, string> = {
  primary: "bg-primary",
  info: "bg-info",
  success: "bg-success",
  warning: "bg-warning",
  danger: "bg-danger",
};

/** CSS custom-property name backing each tone — for the ring's gradient stops, which need an actual colour value rather than a utility class. */
export const TONE_VAR: Record<TWidgetTone, string> = {
  primary: "--color-primary",
  info: "--color-info",
  success: "--color-success",
  warning: "--color-warning",
  danger: "--color-danger",
};

/**
 * Whether to animate at all. Every primitive below routes through this rather
 * than each deciding for itself, so "reduce motion" means reduce motion across
 * the whole canvas and not in seven places out of ten.
 *
 * Reads the canvas-level environment rather than opening its own `matchMedia`
 * subscription: this is called once per primitive *instance*, and a full canvas
 * has a dozen of them watching a preference that changes approximately never.
 */
export const useAnimationsEnabled = () =>
  useWidgetEnvironment().animationsEnabled;
